import { render, staticRenderFns } from "./DetailsV2.vue?vue&type=template&id=3c06b0ea&scoped=true"
import script from "./DetailsV2.vue?vue&type=script&lang=js"
export * from "./DetailsV2.vue?vue&type=script&lang=js"
import style0 from "./DetailsV2.vue?vue&type=style&index=0&id=3c06b0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c06b0ea",
  null
  
)

export default component.exports